import React from "react";
import {
  FaBuilding,
  FaMapMarkerAlt,
  FaLayerGroup,
  FaExclamationTriangle,
} from "react-icons/fa";


function StatCard({ label, value, icon: Icon, tone = "blue" }) {
  const tones = {
    blue: "from-sky-500/15 to-blue-500/5 text-sky-700 dark:text-sky-300",
    emerald:
      "from-emerald-500/15 to-lime-500/5 text-emerald-700 dark:text-emerald-300",
    violet:
      "from-violet-500/15 to-fuchsia-500/5 text-violet-700 dark:text-violet-300",
    amber:
      "from-amber-500/15 to-orange-500/5 text-amber-700 dark:text-amber-300",
  };

  return (
    <div className="rounded-3xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-950/40 p-4 shadow-sm">
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="text-xs uppercase tracking-wider text-slate-500 dark:text-slate-400 font-semibold">
            {label}
          </div>
          <div className="mt-2 text-3xl font-bold text-slate-900 dark:text-white">
            {value}
          </div>
        </div>

        <div
          className={`rounded-2xl p-3 bg-gradient-to-br ${tones[tone] || tones.blue}`}
        >
          <Icon className="h-5 w-5" />
        </div>
      </div>
    </div>
  );
}

const ClubsDojoStats = ({ stats }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
      <StatCard
        label="Clubs"
        value={stats.totalClubs}
        icon={FaBuilding}
        tone="blue"
      />
      <StatCard
        label="Dojos"
        value={stats.totalDojos}
        icon={FaMapMarkerAlt}
        tone="emerald"
      />
      <StatCard
        label="Groupes"
        value={stats.totalGroups}
        icon={FaLayerGroup}
        tone="violet"
      />
      <StatCard
        label="Clubs sans dojo"
        value={stats.clubsSansDojo}
        icon={FaExclamationTriangle}
        tone="amber"
      />
    </div>
  );
};

export default ClubsDojoStats;